import { Container } from '../../../odie';

import { CageBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'cage/block.cage.front.png',
};

/*
    cage block view
*/
export class CageBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: CageBlockProps) {
    // create base view
    super();

    const bubble = new FitWidthBlockSprite(manifest.image, props);

    bubble.scaleX *= 1.35;
    bubble.scaleY *= 1.35;
    bubble.y = 0;

    this.addChild(bubble);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
